import {
  ACTION_GET_ORGANIZATION_BANK_ACCOUNT,
  ACTION_GET_ORGANIZATION_BANK_ACCOUNT_SUCCESS,
  ACTION_GET_ORGANIZATION_BANK_ACCOUNT_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

export function getBankAccount(organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/bank-account`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_ORGANIZATION_BANK_ACCOUNT,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_ORGANIZATION_BANK_ACCOUNT_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_ORGANIZATION_BANK_ACCOUNT_FAILURE,
    payload: responseJSON,
  };
}
